import { render, staticRenderFns } from "./QuotationOrder.vue?vue&type=template&id=bf1e1624"
import script from "./QuotationOrder.vue?vue&type=script&lang=js"
export * from "./QuotationOrder.vue?vue&type=script&lang=js"
import style0 from "./QuotationOrder.vue?vue&type=style&index=0&id=bf1e1624&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports